import React, { useEffect, useState } from 'react';

import Icon from '@ant-design/icons';
import FilterIcon from '@icons/emp/filter-icon.svg';

import { NavList, Tab, Wrapper } from './styled';
import { ITabsItem, ITabsProps } from './typed';

function isStringArray(array: any[]): array is string[] {
  return array.every((item) => typeof item === 'string');
}

function transformStringArrayToTabsItems(array: string[]): ITabsItem[] {
  return array.map((item) => ({ key: item, label: item }));
}

function convertToTabsItems(inputArray: string[] | ITabsItem[]): ITabsItem[] {
  if (Array.isArray(inputArray)) {
    if (isStringArray(inputArray)) {
      return transformStringArrayToTabsItems(inputArray);
    } else {
      return inputArray as ITabsItem[];
    }
  }
  throw new Error('Input is not a valid string array or ITabsItem array.');
}

const Tabs: React.FC<ITabsProps> = ({ items: tabsItems = [], activeTabKey, onClick }) => {
  const items = convertToTabsItems(tabsItems);

  const [activeTab, setActiveTab] = useState<ITabsItem>(items[0]);

  useEffect(() => {
    const findItem = items.find((item) => activeTabKey && item.key === activeTabKey);
    findItem && setActiveTab(findItem);
  }, [activeTabKey, items]);

  const List = items.map((item, index) => {
    const { key, label } = item;
    return (
      <Tab
        key={`${key}__${index}`}
        active={key === activeTab.key}
        onClick={() => {
          setActiveTab(item);
          onClick?.(item);
        }}
      >
        {label}
      </Tab>
    );
  });

  return (
    <Wrapper>
      <NavList>
        <Icon component={FilterIcon} style={{ fontSize: 14, marginRight: 12 }} />
        {List}
      </NavList>
    </Wrapper>
  );
};

export default Tabs;
